export const TX_FEE = 1000;
export const PURRSER_ADDRESS = 'req';
export const PURRSER_FEE = 5000;
// max group size is 16 = 15 + fee transaction
export const MAX_GROUP_SIZE = 15;
export const OPT_FEE = 100000;
export const PASSWORD_KEY = 'purrserkey';
export const FETCH_TIMER = 7000;
export const ZERO_ADDRESS = 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAY5HFKQ';
